import React, { useMemo } from 'react';
import {
  resolveSimulationMatrixForSandbox,
  type SandboxPayload,
  type SimulationMatrixPayload,
} from '@interactive-room';

/** Vista previa en miniatura de la matriz de impresión Explora. */
export function PrintMatrixPreview({
  payload,
  topicHint = '',
  subjectTag,
}: {
  payload: Record<string, unknown>;
  topicHint?: string;
  subjectTag?: string;
}) {
  const matrix = useMemo(() => {
    try {
      return resolveSimulationMatrixForSandbox(
        payload as SandboxPayload,
        topicHint,
        subjectTag ?? null,
      );
    } catch {
      return null;
    }
  }, [payload, topicHint, subjectTag]);

  if (!matrix) {
    return (
      <p className="text-[11px] text-[var(--sala-field-dim)]">
        No se pudo generar la vista previa de impresión.
      </p>
    );
  }

  return <MatrixPreviewTable matrix={matrix} />;
}

function MatrixPreviewTable({ matrix }: { matrix: SimulationMatrixPayload }) {
  return (
    <div className="print-matrix-preview">
      <p className="print-matrix-preview__title">{matrix.title}</p>
      <p className="print-matrix-preview__instruction">{matrix.instructionText}</p>
      <div className="print-matrix-preview__table-wrap">
        <table className="print-matrix-preview__table">
          <thead>
            <tr>
              {matrix.headers.map((h, i) => (
                <th key={i}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {matrix.rows.map((row) => (
              <tr key={row.id}>
                {row.cells.map((cell, ci) => (
                  <td key={ci}>
                    {cell.isHiddenInput ? (
                      <span className="print-matrix-preview__blank">
                        {cell.placeholderLabel || '___'}
                      </span>
                    ) : (
                      cell.value
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {matrix.workspace && (
        <p className="print-matrix-preview__workspace">
          Espacio de cálculos · {matrix.workspace.gridType} · {matrix.workspace.heightRows} filas
        </p>
      )}
    </div>
  );
}
